export default "__VITE_ASSET__EIJUmhmx__"